import { motion } from 'framer-motion';

export const CurrencySelector = ({ selected, onChange, compact = false }) => {
  const currencies = [
    {
      id: 'usdr',
      label: 'USD',
      icon: (
        <img src="/assets/poll/usdr.svg" alt="img" className='img-fluid' />
      ),
    },
    {
      id: 'rain',
      label: 'RAIN',
      icon: (
         <img src="\assets\genrate-market-imgs\rain.svg" alt="img" className='img-fluid' />
      ),
    },
  ];

  if (compact) {
    return (
      <div className="gm-currency-compact">
        {currencies.map((c) => (
          <button
            key={c.id}
            onClick={() => onChange(c.id)}
            className={`gm-currency-compact-btn ${
              selected === c.id
                ? 'gm-currency-compact-btn--active'
                : 'gm-currency-compact-btn--inactive'
            }`}
          >
            <span className="gm-currency-compact-label">
              {c.icon}
              {c.label}
            </span>
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className="gm-currency-full">
      {currencies.map((c) => (
        <motion.button
          key={c.id}
          whileTap={{ scale: 0.95 }}
          onClick={() => onChange(c.id)}
          className={`gm-currency-full-btn ${
            selected === c.id
              ? 'gm-currency-full-btn--active'
              : 'gm-currency-full-btn--inactive'
          }`}
        >
          {c.icon}
          <span className={`gm-currency-full-label ${selected === c.id ? 'gm-currency-full-label--active' : ''}`}>
            {c.label}
          </span>
        </motion.button>
      ))}
    </div>
  );
};
